import { getBaseHost, isUrlHasHttpPart, placeHolderImage } from "../url/url";

// title, description and keywords are taken from https://legacy.egwwritings.org
export const titleBrief = "EGW";
export const titleShortDefault = "EGW Writings";
export const titleDefault = "EGW Writings®: The Complete Published Books of Ellen G. White";
export const descriptionDefault = "Search, read, listen to, and download Ellen G. White's " +
  "Writings in multiple languages! Publications are available in epub, mobi, Kindle, MP3 and PDF " +
  "formats.";
export const keywordsDefault = "egw, egwwritings, Ellen G. White Writings, Ellen White, " +
  "ellenwhite, ellengwhite, ellen g. white, e g white, white estate, " +
  "ellen g white estate, MP3, Kindle, ePub, PDF, Books, Periodicals, Manuscripts, Biography, " +
  "most prolific American woman author, most translated woman writer in history, test of a true " +
  "prophet, spirit of prophecy, Adventist, Pioneer, SDA, Bible, AKJV, ASV, Darby, KJV, WBS, WEB, " +
  "Young’s Literal, Noah Webster’s 1828 American Dictionary";

export const urlImageDefault = isUrlHasHttpPart(placeHolderImage)
  ? placeHolderImage
  : getBaseHost() + placeHolderImage;
export const altImageDefault = "Default cover of EGW book";
